import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {EditCompanyArea} from "../../components/CompanyComponents";
import {closeDialog, openDialog} from "../../slices/dialog";
import {selectAreas, selectMacroareas, storeAreas, storeMacroareas} from "../../slices/profile";
import {getCompanyAreasListener} from "../../api/company";
import SectionNavbar from "../../components/SectionNavbar";
import AddIcon from "@material-ui/icons/Add";
import {CompanyAreas} from "../../components/CommonComponents";
import Button from "../../components/Common/Button";
import {Cookies} from "react-cookie-consent";
import {CompanyWelcome} from "../../components/Dialog/Company/Welcome";
import CompanyMacroareas from "./components/CompanyMacroareas/CompanyMacroareas";
import {getCompanyMacroareasListener} from "../../api/company/macroArea";
import {useTranslation} from "react-i18next";

export const CompanyDashboard = () => {
    const dispatch = useDispatch();
    const areas = useSelector(selectAreas);
    const macroareas = useSelector(selectMacroareas);
    const [filteredAreas, setFilteredAreas] = useState([]);
    const [selectedMacroarea, setSelectedMacroarea] = useState();
    const {t} = useTranslation();

    const onAddArea = () => {
        dispatch(openDialog({
            Content: EditCompanyArea,
            title: t("company_addArea_title"),
            closable: true
        }));
    }

    // const onAreaDelete = (areaIndex) => {
    // 	deleteArea(areas[areaIndex]);
    // };

    // useEffect(() => {
    // 	getCompanyTimeFollowers().then(values => {
    // 		const timeChartCoords = getTimeChartCoords(values);
    // 		setTimeChartCoords(timeChartCoords);
    // 	});
    // }, [])

    useEffect(() => {
        const unsubscribe = getCompanyAreasListener({
            next: (snapshot) => {
                const areas = snapshot.docs.map((doc) => doc.data());
                dispatch(storeAreas(areas));
            }
        });
        return unsubscribe;
    }, [dispatch])

    useEffect(() => {
        const unsubscribe = getCompanyMacroareasListener({
            next: (snapshot) => {
                const macroareas = snapshot.docs.map((doc) => doc.data());
                dispatch(storeMacroareas(macroareas));
            }
        });
        return unsubscribe;
    }, [dispatch])

    useEffect(() => {
        const tutorialDone = Cookies.get("areasTutorialDone");

        dispatch(closeDialog());
        if (!tutorialDone)
            dispatch(openDialog({
                Content: CompanyWelcome,
                props: {},
                closable: false,
                narrow: true
            }));
    }, [dispatch])

    const handleSelectMacroarea = macroarea => {
        setSelectedMacroarea(macroarea);
    }

    useEffect(() => {
        if (!selectedMacroarea) setFilteredAreas(areas);
        else {
            const fa = areas.filter(area => area?.macroareaId === selectedMacroarea.id)
            setFilteredAreas(fa);
        }
    }, [selectedMacroarea, areas])

    useEffect(() => {
        if (!selectedMacroarea) return;

        const selectedMacroareaId = selectedMacroarea.id;
        const updatedSelectedMacroarea = macroareas.find(macro => macro.id === selectedMacroareaId)
        setSelectedMacroarea(updatedSelectedMacroarea);
    }, [macroareas])

    return (
        <div className='companyDashboard'>
            <SectionNavbar>
                <h2>{t("company_vivaio_title")}</h2>
                <Button onClick={() => onAddArea()}>
                    <AddIcon/>
                    <div className="text">{t("company_vivaio_addAreaBtn")}</div>
                </Button>
            </SectionNavbar>
            <CompanyMacroareas selectMacroarea={handleSelectMacroarea} selectedMacroarea={selectedMacroarea}/>
            <CompanyAreas areas={filteredAreas}/>

            {/* <div className="companyDashboard__title">Dashboard del Vivaio</div>
			<div className="row">
				<CardTimeChart values={timeChartCoords} />
				<CardPieChart getGenderValues={getGenderValues} />
			</div> */}
        </div>
    );
};